export default __webpack_public_path__ + "static/lpr-video-b1f8f248d46282e4c69e14e2e9fd1bc1.mp4";